import { render, staticRenderFns } from "./IconPodbeanLogo.vue?vue&type=template&id=62d312fb&scoped=true&"
import script from "./IconPodbeanLogo.vue?vue&type=script&lang=js&"
export * from "./IconPodbeanLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d312fb",
  null
  
)

export default component.exports